export default __webpack_public_path__ + "static/media/right-back.076d63d0.svg";